import React, { useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as mh from 'helpers/medicationHelpers.js';
import * as gh from 'helpers/generalHelpers.js';
import { deleteMedicationInDb, updateMedicationInDb } from 'store/localDb';
import { getMedsHistory } from 'store/storeValtio';
import { updateMed, deleteMed } from 'store/storeValtio';
import ConfirmModal from '../../common/ConfirmModal';
import chevLeft from 'icons/chevron-left-24.png';
import moment from 'moment';
import MedicationSummary from '../addMedication/MedicationSummary';

export default function MedicationDetails(props) {
  const [refresh, setRefresh] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    medName: '',
    taken: null,
    id: null,
  });
  const navigate = useNavigate();

  const params = useParams();
  //console.log('MedDetails',params);
  const medId = params.id;
  const med = useMemo(() => mh.lookupMed(medId), []);
  const nddt = useMemo(() => mh.nextDueDateTime(med), []);
  const glh = useMemo(() => mh.getLatestHistory(med.medicationId), []);

  const medsHistory = getMedsHistory();
  const nextDue = nddt ? moment(nddt).format("MM/DD hh:mm A") : 'No Due Date';
  const lastTaken = glh ? moment(glh.date).format("MM/DD hh:mm A") : 'Never';

  var hist = useMemo(() => medsHistory.filter((h) => h.medicationId === medId),[]);
  var latestPre = mh.getLatestPrescription(medId);
  //console.log('latestPre', medId, latestPre);

  //console.log('today', todayJD);
  //console.log('latest history', glh);
  //console.log('due', nddt, nextDue, lastTaken);

  var today = 0;
  var yesterday = 0;
  var sevenDays = 0;
  var thirtyDays = 0;

  function getCounts() {
    today = 0;
    yesterday = 0;
    sevenDays = 0;
    thirtyDays = 0;
    const todayJD =  gh.getJD(moment())
    //console.log(todayJD);
    hist.forEach((h,ix) => {
      //console.log('counts', h.quantity, typeof h.quantity);
      const c = h.quantity;
      const taken = moment(h.date);
      const takenJD = gh.getJD(taken);
      const days = todayJD - takenJD;
      //console.log(days);
      if (days === 0) today += c;
      else if (days === 1) yesterday += c;
      if (days < 6) sevenDays += c;
      if (days < 29) thirtyDays += c;
    });
  };
  useMemo(() => getCounts(),[]);


  function goTo(target) {
    navigate(target);
    return;
  }

  function doEdit() {
    console.log('doEdit', med.medicationId);
    navigate(`/create/${med.medicationId}`);
    // if (item === editItem) item = 'none';
    // setEditItem(item);
  }

  async function doPause(pause) {
    console.log('doPause', med.isPaused, pause);
    med.isPaused = pause;
    await updateMedicationInDb(med);
    updateMed(med);
    setRefresh(!refresh);
  }

  // This will show the Cofirmation Box
  const handleDelete = () => {
    console.log('handleDelete', med.medicationId, med.name);
    setPopup({ show: true, medName: med.name, id: med.medicationId });
  };

  // This will perform the deletion and hide the Confirmation Box
  const handleDeleteTrue = () => {
    handleDeleteMed(popup.id);
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"
  const handleDeleteFalse = () => {
    setPopup({ show: false, taken: null, id: null });
  };

  async function handleDeleteMed(mid) {
    console.log('handleDeleteMed', mid);
    await deleteMedicationInDb(mid);
    console.log('deleted', mid);
    deleteMed(mid); // remove med from store
    //setMedsLoaded(false); // force reload 
    setPopup({ show: false, taken: null, id: null });
    navigate('/');
  }

  function doPrescription() {
    console.log('doPrescription', latestPre);
    if (!latestPre)
      navigate('/addPrescription/' + medId);
    else
      navigate('/prescriptions/' + medId);
  }

  //const hideSum = editItem !== 'none';
  //console.log('hideSum', hideSum, editItem)
  console.log('type', med.type );
  return (
    <div>
      <ConfirmModal 
        open={popup.show} 
        onConfirm={()=>handleDeleteTrue()}
        onCancel={()=>handleDeleteFalse()}
        title={popup.medName}
        content='Do you really want to delete this medication?'
        confirmButton='Delete'
        />
      <div className='mcard'>
        <div className='mcard-screen flex flex-row items-center'>
          {/* <div className='hover:cursor-pointer' onClick={()=>goTo(-1)}>
            <img src={chevLeft} alt='' />
          </div> */}
          <div className='w-full pl-4'>
            {med.name}
          </div>
        </div>
        <div className='mx-4'>
          <div className='medBody border-b-2'>
            {/* <div className='mcard-title justify-center'>
              {med.description}
            </div> */}
            <div className='inline-flex justify-center mt-1 w-full'>
              <button onClick={()=>goTo(`/take/${med.medicationId}/details`)} className='mbtn w-3/12 mr-2 bg-green-500'>Take</button>
              { (med.isPaused) &&
                <button onClick={()=>doPause(false)} className='mbtn w-3/12 mr-2 bg-green-500'>Resume</button>
              }
              { (!med.isPaused) &&
                <button onClick={()=>doPause(true)} className='mbtn w-3/12 mr-2 bg-red-500'>Pause</button>
              }
              <button onClick={()=>doEdit()} className='mbtn w-3/12 mr-2 bg-blue-500'>Edit</button>
              <button onClick={()=>handleDelete()} className='mbtn w-3/12 mr-2 bg-red-500'>Delete</button>
            </div>
            { (med.type === 'S') &&
            <div className='w-full mt-2 flex justify-center'>
              <button onClick={()=>goTo(`/ingredients/${med.medicationId}`)} className='mbtn w-8/12 mr-2 bg-blue-200'>Show Ingredient Data</button>
            </div>
            }
          </div>
          <div className='flex flex-col w-full justify-center items-center'>
            <table className='w-10/12 mt-4 text-base small:text-lg font-semibold'>
              <thead></thead>
              <tbody>
                <tr className='zebra'>
                  <td>Taken today:</td>
                  <td className='w-24'>{today}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken yesterday:</td>
                  <td>{yesterday}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken past 7 days:</td>
                  <td>{sevenDays}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken past 30 days:</td>
                  <td>{thirtyDays}</td>
                </tr>
              </tbody>
            </table>
            <table className='w-10/12 mt-2 text-base small:text-lg font-semibold'>
              <thead></thead>
              <tbody>
              <tr className='zebra'>
                  <td>Last taken:</td>
                  <td>{lastTaken}</td>
                </tr>
                <tr className='zebra'>
                  <td>Next due:</td>
                  <td>{nextDue}</td>
                </tr>
                {latestPre && 
                <tr>
                  <td>Last filled::</td>
                  <td>{gh.ISOToMMDDYYYY(latestPre.dateFilled)}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <MedicationSummary summary={med} />
      {(med.type === 'P') && 
      <div className='w-full mt-4 mx-4'>
        <button 
          onClick={()=>doPrescription()} 
          className='mbtn px-2 mr-2 bg-blue-500'
          >
            {latestPre ? 'Show Prescription Information' : 'Add Prescription Information'}
          </button>

      </div>
      }
    </div>  
  );
}
